/* eslint-disable no-unused-vars */
import { Box, Button, Flex, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../LoadingSpinner";
import SearchCaseModal from "../Common/SearchCaseModal";
// import { demoCaseData } from "../../utils/demoData";
import FormComponent from "../SharedComponent/FormComponent";

const Cases = () => {
  const [clickedCaseId, setClickCaseId] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [caseData, setCaseData] = useState({});

  const {
    isOpen: isSearchBoxOpen,
    onOpen: onSearchBoxOpen,
    onClose: onSearchBoxClose,
  } = useDisclosure();

  useEffect(() => {
    if (clickedCaseId.id) {
      setIsLoading(true);
      fetch(
        `/api/getcase?id=${clickedCaseId.id}&source=${clickedCaseId.source}`
      )
        .then((response) => response.json())
        .then((json) => {
          setCaseData(json);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  }, [clickedCaseId.id, clickedCaseId.source]);

  const handleSearchBoxClick = () => {
    onSearchBoxOpen();
  };

  return (
    <Box m={10}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        my={5}
        flexDir={{ base: "column", md: "row" }}
        gap={4}
      >
        <Box w={{ base: "100%", md: "100px" }}>
          <Button
            variant="primaryButton"
            onClick={handleSearchBoxClick}
            w={{ base: "100%" }}
          >
            Search Case
          </Button>
        </Box>
      </Flex>
      <Box borderTopWidth="medium" borderTopColor="bgColor" m={2}>
        {Object.keys(caseData)?.length === 0 ? (
          ""
        ) : (
          <Box width="100%">
            {isLoading ? (
              <Box textAlign="center">
                <LoadingSpinner />
              </Box>
            ) : (
              <FormComponent data={caseData} />
            )}
          </Box>
        )}
        {/* 
        <Box width="100%">
          {isLoading ? (
            <Box textAlign="center">
              <LoadingSpinner />
            </Box>
          ) : (
            <FormComponent data={demoCaseData} />
          )}
        </Box> */}
      </Box>
      {
        <SearchCaseModal
          isOpen={isSearchBoxOpen}
          onClose={onSearchBoxClose}
          onOpen={onSearchBoxOpen}
          clickedCaseId={clickedCaseId}
          setClickCaseId={setClickCaseId}
        />
      }
    </Box>
  );
};

export default Cases;
